
import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'

export default function DetailsIcon(props) {
    const { selected } = props;
    const classes = useStyles({selected, ...props})()

    return(
        <svg className={classes.container} width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.3895 0C18.9933 0 21 2.07667 21 5.635V17.6867C21 21.3033 18.9933 23.3333 15.3895 23.3333H5.61167C2.065 23.3333 0 21.3033 0 17.6867V5.635C0 2.07667 2.065 0 5.61167 0H15.3895ZM5.92667 16.03C5.57667 15.995 5.23833 16.1583 5.05167 16.4617C4.865 16.7533 4.865 17.1383 5.05167 17.4417C5.23833 17.7333 5.57667 17.9083 5.92667 17.8617H15.0733C15.5388 17.815 15.89 17.4172 15.89 16.9517C15.89 16.4733 15.5388 16.0767 15.0733 16.03H5.92667ZM15.0733 10.7088H5.92667C5.42383 10.7088 5.01667 11.1183 5.01667 11.62C5.01667 12.1217 5.42383 12.53 5.92667 12.53H15.0733C15.575 12.53 15.9833 12.1217 15.9833 11.62C15.9833 11.1183 15.575 10.7088 15.0733 10.7088ZM9.41383 5.425H5.92667V5.43667C5.42383 5.43667 5.01667 5.845 5.01667 6.34667C5.01667 6.84833 5.42383 7.25667 5.92667 7.25667H9.41383C9.91667 7.25667 10.325 6.84833 10.325 6.33383C10.325 5.83333 9.91667 5.425 9.41383 5.425Z" />
        </svg>
    )
}


const useStyles = ({selected, ...props}) => makeStyles((theme) => ({
    container:{
        '& path': {
            fill: selected ? "#FFF" : theme.palette.secondary.main,
            width: props.width,
         },
    }
}));